export default __webpack_public_path__ + "static/media/img-0373-ovato-nation-half-face.f2378200.png";